import { render, staticRenderFns } from "./HomeFooter.component.vue?vue&type=template&id=56e1e854&scoped=true"
import script from "./HomeFooter.component.vue?vue&type=script&lang=js"
export * from "./HomeFooter.component.vue?vue&type=script&lang=js"
import style0 from "./HomeFooter.component.vue?vue&type=style&index=0&id=56e1e854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e1e854",
  null
  
)

export default component.exports